export const enamelPaintingRowCells = [
    [
        {
            className: '',
            placeholder: '',
            id: 'enamel-painting-work-order-no',
            name: 'workOrderId',
            value: 'workOrderId',
        },
    ],
    [
        {
            className: '',
            placeholder: '',
            id: 'enamel-painting-product-name',
            name: 'productCode',
            value: 'productCode',
        }
    ],
    [
        {
            className: '',
            placeholder: '',
            id: 'enamel-painting-starting-time',
            name: 'startingTime',
            value: 'startingTime',
            datePicker: true,
        }
    ],
    [
        {
            className: '',
            placeholder: '',
            id: 'enamel-painting-ending-time',
            name: 'endingTime',
            value: 'endingTime',
            datePicker: true,
        },
    ],
    [
        {
            className: '',
            placeholder: '',
            id: 'enamel-painting-hanged',
            name: 'hungCount',
            value: 'hungCount',
            number: true
        }
    ]
]